// M15: 三角學 - Trigonometry
// 系統化數據結構，準備 Supabase 後端遷移

export const M15_MODULE_INFO = {
  moduleId: 'M15',
  title: '三角學',
  titleEn: 'Trigonometry',
  description: '學習三角函數的性質和應用',
  totalTopics: 8,
  estimatedTime: '12-15小時',
  difficulty: 'intermediate',
  prerequisites: ['M04', 'M08'],
  learningObjectives: [
    '理解三角函數的定義',
    '掌握三角恆等式',
    '解三角方程',
    '分析三角函數圖像',
    '應用複合角公式'
  ]
};

export const M15_TOPICS = [
  {
    id: 'M15_01',
    name: "三角函數定義",
    description: "三角函數的基本定義和概念",
    order: 1,
    subTopics: [
      "角度制和弧度制",
      "三角函數的定義",
      "單位圓中的三角函數",
      "特殊角的三角函數值",
      "三角函數的符號"
    ]
  },
  {
    id: 'M15_02',
    name: "基本三角恆等式",
    description: "基礎三角恆等式的推導和應用",
    order: 2,
    subTopics: [
      "基本恆等式",
      "平方和恆等式",
      "商的恆等式",
      "互餘角恆等式",
      "恆等式的證明"
    ]
  },
  {
    id: 'M15_03',
    name: "三角函數圖像",
    description: "三角函數的圖像性質",
    order: 3,
    subTopics: [
      "正弦函數圖像",
      "餘弦函數圖像",
      "正切函數圖像",
      "圖像的變換",
      "週期性和對稱性"
    ]
  },
  {
    id: 'M15_04',
    name: "複合角公式",
    description: "兩角和差的三角函數公式",
    order: 4,
    subTopics: [
      "兩角和的公式",
      "兩角差的公式",
      "倍角公式",
      "半角公式",
      "三倍角公式"
    ]
  },
  {
    id: 'M15_05',
    name: "三角方程",
    description: "三角方程的解法",
    order: 5,
    subTopics: [
      "基本三角方程",
      "複合三角方程",
      "三角方程組",
      "條件三角方程",
      "參數三角方程"
    ]
  },
  {
    id: 'M15_06',
    name: "三角函數的性質",
    description: "三角函數的詳細性質分析",
    order: 6,
    subTopics: [
      "週期性",
      "奇偶性",
      "單調性",
      "有界性",
      "最值問題"
    ]
  },
  {
    id: 'M15_07',
    name: "反三角函數",
    description: "反三角函數的定義和性質",
    order: 7,
    subTopics: [
      "反正弦函數",
      "反餘弦函數",
      "反正切函數",
      "反三角函數的性質",
      "反三角函數的應用"
    ]
  },
  {
    id: 'M15_08',
    name: "三角學應用",
    description: "三角學在各領域的應用",
    order: 8,
    subTopics: [
      "解三角形",
      "三角測量",
      "波動現象",
      "週期現象建模",
      "物理中的三角應用"
    ]
  }
];

// 導出模組統計信息
export const M15_STATS = {
  totalTopics: M15_TOPICS.length,
  totalSubTopics: M15_TOPICS.reduce((sum, topic) => sum + topic.subTopics.length, 0),
  estimatedHours: 15,
  difficultyLevel: 2, // 1-3 scale
  prerequisiteModules: 2
}; 